import React from 'react';
import Favorite from '../../../../shared/Events/Table/Favorite/Favorite';
import EventInfo from '../../../../shared/Events/Table/EventInfo/EventInfo';
import Mbn from '../../../../shared/Events/Table/Mbn/Mbn';
import MoreMarkets from '../../../../shared/Events/Table/MoreMarkets/MoreMarkets';
import { useSelector } from 'react-redux';
import Statistics from '../../../../shared/Events/Table/Statistics/Statistics';
import { getStatisticsUrl } from '../../../../../utils/render';
import Sport from '../../../../shared/SportIcons/Sport';
import styles from './Row.module.scss';
import { getMoreMarketsUrl, isESportEvent } from '../../../../../utils/helpers';
import { useHistory } from 'react-router-dom';
import { LANGUAGES } from '../../../../../constants/defaultValues';

const Row = ({ event }) => {
    const history = useHistory();
    const locale = useSelector(state => state.settings.locale);
    const leagues = useSelector(state => state.sportEvents.filters.leagues) || [];
    const { isESports } = useSelector(state => state.sportEvents);

    const { id, programCode, teams, startedAt, mbn, sportTypeRefId, league } = event;
    const currentSeasonId = event.currentSeasonId || '';

    const foundLeague = leagues.find(league => league.id === event.seasonRefId);
    const eventLeague = foundLeague?.names[locale] || foundLeague?.names[LANGUAGES.eng] || '';
    const homeTeamId = teams.homeCompetitorId?.slice(16);
    const awayTeamId = teams.awayCompetitorId?.slice(16);
    let seasonId = currentSeasonId?.split(':');
    seasonId = seasonId[seasonId.length - 1];
    let eventId = id?.replace('1:', '');
    const statisticsUrl = getStatisticsUrl({ seasonId, eventId, homeTeamId, awayTeamId });

    const onRowClick = () => {
        const redirectUrl = getMoreMarketsUrl({ event });
        history.push(redirectUrl);
    };

    return (
        <tr onClick={onRowClick} className={'cursor-pointer'}>
            <Favorite isFavorite programCode={programCode} id={id} />
            <td className={styles.sportIcon}>
                <Sport sportId={sportTypeRefId} isActive />
            </td>
            <EventInfo
                eventId={id}
                league={eventLeague}
                teams={teams}
                categoryName={league.categoryName}
            />
            <Statistics isLive={false} startedAt={startedAt} />
            <Mbn mbn={mbn} statisticsUrl={statisticsUrl} isESports={isESports} />
            <MoreMarkets event={event} />
        </tr>
    );
};

export default Row;
